import {enqueueAnalyticsEvent} from '../../analytics/analyticsClient'

const OUTCOMES = {
  sync: 'Nível de Serviço · Resultado da sincronização',
  sla_seller: 'Nível de Serviço · Resultado do SLA por Seller',
  sla_region: 'Nível de Serviço · Resultado do SLA por região',
  seller_export: 'Nível de Serviço · Resultado da exportação dos pedidos',
  pedido_export: 'Nível de Serviço · Resultado da exportação do pedido',
  scope: 'Nível de Serviço · Resultado das permissões e do escopo',
} as const

export function trackServiceLevelOutcome(
  action: keyof typeof OUTCOMES,
  success: boolean,
  metadata: Record<string, unknown> = {},
  path = window.location.pathname
) {
  try {
    enqueueAnalyticsEvent({
      event_type: 'feature_use',
      event_name: OUTCOMES[action],
      path,
      success,
      metadata: {...metadata, module: 'service-level', action, stage: 'result'},
    })
  } catch (_) {
    // Telemetria opcional não interrompe a ação do usuário.
  }
}

export async function measureServiceLevelAction<T>(
  action: keyof typeof OUTCOMES,
  request: () => Promise<T>,
  metadata: Record<string, unknown> = {}
): Promise<T> {
  const path = window.location.pathname
  const startedAt = performance.now()
  try {
    const result = await request()
    const success = !(
      result &&
      typeof result === 'object' &&
      'ok' in result &&
      (result as unknown as {ok: unknown}).ok === false
    )
    trackServiceLevelOutcome(
      action,
      success,
      {...metadata, duration_ms: performance.now() - startedAt},
      path
    )
    return result
  } catch (error) {
    trackServiceLevelOutcome(
      action,
      false,
      {...metadata, duration_ms: performance.now() - startedAt},
      path
    )
    throw error
  }
}
